import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { UAEPassResponse } from '../views/interface/apiResponseInterface';

@Injectable({
  providedIn: 'root'
})
export class uaepassService {
  private apiUrl = Environment.integrationURL;

  private uaePassConfig = Environment.uaePassConfig;

  constructor(private http: HttpClient, private route: Router, @Inject(DOCUMENT) private document: Document) { }

  redirectToAuthenticate() {
    //var authURL = `${this.uaePassConfig.url}authorize?response_type=code&client_id=${this.uaePassConfig.client_id}&scope=${this.uaePassConfig.scope_resident}&redirect_uri=${this.uaePassConfig.redirect_url}`;
    var authURL = `${this.uaePassConfig.url}authorize?response_type=code&client_id=${this.uaePassConfig.client_id}&scope=${this.uaePassConfig.scope_resident}&state=HnlHOJTkTb66Y5H&redirect_uri=${this.uaePassConfig.redirect_url}&acr_values=urn:safelayer:tws:policies:authentication:level:low`;
    return this.document.location.href = authURL;
  }

  async getUserInfoFromIntegration(accessCode: string) {
    let request = { 
      AccessCode: accessCode,
      rredirectURI: this.uaePassConfig.redirect_url
    };
    await this.http.post(`${this.apiUrl}/api/Auth/UAEPassCallback`, request).subscribe(async (res: any) => {
      if (res && res.statusCode != 200) {
        return { error: "Failed to generate Access token." };
      }
      else {
        var userInformation = res.result as UAEPassResponse;
        return userInformation;
      }
    });
  }

}
